import axiosInstance from "../server/axios";

export const updateCurrencies = async (data) => {
    const token = localStorage.getItem('authToken');
    const response = await axiosInstance.put(`/currencies/${data.id}`, data, {
        headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'

        }
    });
    return response;
};

export const getCurrencies = async () => {
    const response = await axiosInstance.get("/currencies");
    return response;
};
